import moment from 'moment';

import { DateFormat } from '../../../../../../../utils/date';
import { ActivityTypes } from '../../../../../../../Model/Activity';

import texts from './texts.json';

const formatTimestamp = (timestamp) => moment(timestamp).format(DateFormat.CHAT_TIMESTAMP_FORMAT);

const workoutMessageFormat = (workout) => workout.map((activity) => {
  if (activity.type === ActivityTypes.REST) {
    return `* ${texts.restPeriod}`;
  }
  if (activity.type === ActivityTypes.CIRCUIT) {
    // eslint-disable-next-line max-len
    return `* ${activity.name || texts.individualExercise}:  ${activity.activities.map((exercise) => `${exercise.name}`).join(', ')}`;
  }
  return `* ${activity.name}`;
}).join('\n');

export {
  formatTimestamp,
  workoutMessageFormat,
};
